<nav class="navbar navbar-expand-lg lightDarkPurple">
  <div class="container-fluid customGapping">
    <a class="navbar-brand" routerLink="">
      <img [src]="logoURL" class="img-fluid logoWidth" alt="instacity-logo" />
    </a>
    <div class="btn-group text-start">
      <button
        type="button"
        class="btn dropdown-toggle custom-btnShadow"
        data-bs-toggle="dropdown"
        data-bs-display="static"
        aria-expanded="false"
      >
        <img
          src="../../../../assets/instaciti-new-img/globe (1) 1.svg"
          class="img-fluid logoWidth42 me-2"
          alt="glob-logo"
        />
        <span *ngIf="selectedCountry" class="countryList">{{
          selectedCountry.CountryName
        }}</span>
      </button>
      <div class="dropdown-menu dropdown-menu-lg-end">
        <input type="text" placeholder="Select Country" (keyup)="filterCountries($event);"
           class="form-control" [(ngModel)]="selecteeCountry"
          [matAutocomplete]="keywords" />
        <mat-autocomplete #keywords="matAutocomplete" (optionSelected)="selectCountry2($event.option.value)">
          <mat-option *ngFor="let item of filteredCountries" [value]="item.CountryName">
            {{item.CountryName}}
          </mat-option>
        </mat-autocomplete>
        <!-- <ul>
          <li *ngFor="let country of countries">
            <button
              class="dropdown-item"
              type="button"
              (click)="selectCountry(country)"
            >
              {{ country.CountryName }}
            </button>
          </li>
        </ul> -->
      </div>
    </div>
    <!-- <a
      class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay"
      href="http://join.instaciti.com/jff"
      target="_blank"
    >
      JOIN FOR FREE
    </a> -->
    <div
      class="collapse navbar-collapse desktopViewDisaplay"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item font16 font600 colorLightBlack me-3">
          <a
            class="nav-link active"
            aria-current="page"
            href="https://play.google.com/store/apps/details?id=com.instaciti.Instaciti.instaciti&pli=1"
            target="_blank"
            ><img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/get-app.svg"
              class="img-fluid me-1"
              alt="getApp"
            />Get App</a
          >
        </li>
        <li class="nav-item me-3 desktopViewDisaplay">
          <a
            class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton"
            href="http://signin.instaciti.com"
            target="_blank"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="true"
            title='
                            <div>Sign Up now & get your free signature
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        '
          >
            JOIN FOR FREE
          </a>
        </li>
        <li class="nav-item customColor">
          <a class="nav-link font16" (click)="support()">Support</a>
        </li>
        <li><a class="nav-link font16">|</a></li>
        <li class="nav-item customColor">
          <a
            class="nav-link font16"
            href="https://manage.instaciti.com/login"
            target="_blank"
            >Login</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="container-fluid">
  <div class="row text-center align-items-center heroSectionBg">
    <div class="col-md-12 customGapping mobileViewPadding">
      <h5 class="font40 font600 text-white">
        Discover great places in {{ location }}
      </h5>
      <h6 class="font26 font400 text-white">{{ locality }}</h6>
      <form autocomplete="off">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Keywords"
              checked="true"
            />
            &nbsp;<span class="text-white align-middle me-4">Keywords</span>
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Business"
            />
            &nbsp;<span class="text-white align-middle me-4"
              >Business Name</span
            >
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Bizspot"
            />
            &nbsp;<span class="text-white align-middle me-4">Bizspot</span>
            <input
              type="radio"
              name="searchBy"
              class="align-middle"
              value="Keywords"
            />
            &nbsp;<span class="text-white align-middle me-4">Collections</span>
          </div>
          <div class="col-md-8 mt-3">
            <div class="input-group">
              <span
                class="input-group-text lightDarkPurple border-end-0 dropdown"
              >
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
                  class="img-fluid"
                  alt="location-icon"
                />
                <span class="font16 font500 ms-1 styled-select">
                  <input
                    class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                    list="datalistOptions2"
                    [placeholder]="localityPlaceholder"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="searchText"
                    [(ngModel)]="searchText"
                    (keyup)="getNearBy()"
                    (focus)="focusLocation()"
                  />
                  <ul
                    class="dropdown-menu p-3 searchDropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li class="lightDarkPurple p-2 rounded customPurple">
                      <img
                        class="img-fluid"
                        src="../../../../assets/instaciti-new-img/Group 17.svg"
                        alt="location"
                      />
                      <span
                        class="locationText cursorPointer ms-2"
                        (click)="setCurrentLocation()"
                        >Detect current location</span
                      >
                    </li>
                    <ng-container *ngIf="!searchText">
                      <p class="font18 font500 customPurple mt-3">
                        Popular cities
                      </p>
                      <ng-container *ngFor="let city of popularCities">
                        <li>
                          <a
                            class="dropdown-item cursorPointer"
                            (click)="selectPopularCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{ city.LocName }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="searchText">
                      <p class="font18 font500 customPurple mt-3">
                        Nearby Location
                      </p>
                      <ng-container *ngFor="let city of nearby">
                        <li>
                          <a
                            class="dropdown-item cursorPointer"
                            (click)="selectNearByCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{
                                city.LocName && city.LocName.length > 50
                                  ? (city.LocName | slice: 0:48) + ".."
                                  : city.LocName
                              }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                  </ul>
                </span>
              </span>
              <input
                class="form-control customInput p-3 border-start-0 border-end-0"
                [placeholder]="placeholder"
                (keyup)="search($event)"
                (focus)="focus($event)"
                [matAutocomplete]="keywords2"
                [(ngModel)]="selectedKeyWord.Keywd"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-autocomplete
                #keywords2="matAutocomplete"
                (optionSelected)="onChange($event.option.value)"
              >
                <mat-option *ngFor="let item of searchResult" [value]="item">
                  {{ item.Keywd }}
                </mat-option>
              </mat-autocomplete>
              <span class="input-group-text bg-white border-start-0"
                ><img
                  src="../../../../assets/instaciti-new-img/Vector (5).svg"
                  alt="location-icon"
              /></span>
            </div>
            <div *ngIf="false" class="dropdown w-100 mt-2">
              <input
                type="text"
                class="form-control customInput p-3 dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="myInput"
                onkeyup="myFunction()"
                placeholder="Chaap Platform"
              />
              <ul
                id="myUL"
                class="dropdown-menu w-100 height358 p-3 textDecorationNone"
                aria-labelledby="myInput"
              >
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">
                          Narela, New Delhi
                        </p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          5.0</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Noida Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">
                          Narela, New Delhi
                        </p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          5.0</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Chaap Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a href="#" class="text-dark">
                    <div class="row">
                      <div class="col-8">
                        <p class="font18 font500 mb-0">Noida Platform</p>
                        <p class="font12 mutedAddress mb-0">Kundli, Sonipat</p>
                        <p class="font12 mutedAddress mb-0">
                          Casual Dining Cost for two: ₹450
                        </p>
                      </div>
                      <div class="col-4 text-end mt-2">
                        <span
                          class="bgCustomPurple text-white font14 ps-1 pe-1 borderRadius2"
                          ><img
                            src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/review-star.png"
                            alt="star-icon"
                          />
                          4.8</span
                        >
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </form>
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="row mt-4 justify-content-center">
            <ng-container *ngIf="manikJson">
              <div
                *ngFor="let item of manikJson.JSon6"
                class="col-md-4 col-6 col-lg-2 d-flex align-items-stretch mt-4"
              >
                <div
                  *ngIf="item.BizSpot"
                  class="card border-0 borderRadius10 cardShadow w-100"
                  (click)="GoToBizSpot(item.URL)"
                >
                  <div class="card-body">
                    <a>
                      <img
                        [src]="item.Logo"
                        class="img-fluid"
                        [alt]="item.BizSpot"
                      />
                    </a>
                    <p>{{ item.BizSpot }}</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-5 customGapping">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-3" *ngIf="!isQuickVisible">
          <portal-instaciti-quick-categories></portal-instaciti-quick-categories>
        </div>
        <div class="col-md-9" *ngIf="!isPromotedVisible">
          <portal-instaciti-promoted-categories></portal-instaciti-promoted-categories>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isPopularVisible">
    <portal-instaciti-popular-categories></portal-instaciti-popular-categories>
  </ng-container>
  <ng-container *ngIf="!isOtherVisible">
    <portal-instaciti-other-categories></portal-instaciti-other-categories>
  </ng-container>
  <div class="row mt-4">
    <div class="col-md-12">
      <h5 class="font26 font500">Give wings to your business</h5>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/join 1.svg"
                class="img-fluid mb-3"
                alt="join"
              />
              <p class="font20 font500 customDarkPurple">Join for free</p>
              <p class="font16 paragraphMutedColor">
                Signup your business for free and enjoy exciting features of
                instaciti to grow your business
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/debit-card 1.svg"
                class="img-fluid mb-3"
                alt="debit-card 1"
              />
              <p class="font20 font500 customDarkPurple">E-payment services</p>
              <p class="font16 paragraphMutedColor">
                List products and services to buy online
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/laptop 1.svg"
                class="img-fluid mb-3"
                alt="laptop 1"
              />
              <p class="font20 font500 customDarkPurple">Site and e-stores</p>
              <p class="font16 paragraphMutedColor">
                Get beautiful website and ecommerce store in few minutes
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/engagement (1) 1.svg"
                class="img-fluid mb-3"
                alt="engagement (1) 1"
              />
              <p class="font20 font500 customDarkPurple">
                Customer engagement tools
              </p>
              <p class="font16 paragraphMutedColor">
                Social media, messaging, deals, personalized offers and loyalty
                programs
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/loudspeaker 1.svg"
                class="img-fluid mb-3"
                alt="loudspeaker 1"
              />
              <p class="font20 font500 customDarkPurple">
                Sales promotion tools
              </p>
              <p class="font16 paragraphMutedColor">
                Email, discounts, coupons
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-12 d-flex align-items-stretch mt-4">
          <div class="row">
            <div class="col-md-12">
              <img
                src="../../../../assets/instaciti-new-img/social-media 1.svg"
                class="img-fluid mb-3"
                alt="social-media 1"
              />
              <p class="font20 font500 customDarkPurple">
                Digital marketing tools
              </p>
              <p class="font16 paragraphMutedColor">
                Social media plugins and marketing, SEO, SEM
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-md-12">
      <h5 class="font26 font500">Popular cities</h5>
    </div>
    <div class="col-md-12 mt-3 textDecorationNone paragraphMutedColor font16">
      <ng-container *ngFor="let city of popularCities; let i = index">
        <a href="#">{{ city.LocName }} </a><span> / </span>
      </ng-container>
    </div>
    <div class="col-md-12 mt-4">
      <div
        class="card border-0 borderRadius10 formBoxShadow negativecardMargin"
      >
        <div class="card-body p-3">
          <form>
            <div class="row">
              <div class="col-md-9">
                <h5 class="font24 font500 customPurple">
                  List your business for FREE
                </h5>
                <div class="row">
                  <div class="col-md-4 mt-3">
                    <input
                      type="text"
                      class="form-control customInput borderRadius10"
                      placeholder="Your Name"
                    />
                  </div>
                  <div class="col-md-4 mt-3">
                    <input
                      type="text"
                      class="form-control customInput borderRadius10"
                      placeholder="Your Name"
                    />
                  </div>
                  <div class="col-md-4 mt-3">
                    <div class="d-grid">
                      <a
                        type="submit"
                        class="btn btn-sm p-2 orangeGradientButton borderRadius10 text-white"
                        
                        href="http://join.instaciti.com/jff"
                        target="_blank"
                      >Contact Us </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <img
                  src="../../../../assets/instaciti-new-img/ctav 1.svg"
                  class="img-fluid negativeMargin"
                  alt="ctav"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<portal-instaciti-footer></portal-instaciti-footer>
